import React from "react";
import moment from "moment";

import { GET_APPLICATION_INFO } from "../../../api/gql";

import withQuery from "../wrappers/gql/withQuery";
import MailClosed from "../../../assets/MailClosed";
import Phone from "../../../assets/Phone";

const MISSING_FIELD = "Unknown";

const PersonalDetails = ({ data: applicationInfo }) => {

  const {
    firstName,
    lastName,
    dob,
    email,
    phoneNumber,
    address: {
      street,
      city,
      unit_number: unitNumber,
      state,
      zip,
    },
  } = applicationInfo?.getApplicationInfo || {};

  const fullName = `${firstName || MISSING_FIELD} ${lastName || MISSING_FIELD}`;
  const streetAddress = `${street || MISSING_FIELD} ${unitNumber || ""}`;
  const restOfAddress = `${city || MISSING_FIELD}, ${state || MISSING_FIELD} ${zip || MISSING_FIELD}`;
  const formattedDob = dob ? moment(dob).format("MM/DD/YYYY") : MISSING_FIELD;
  const displayEmail = email || MISSING_FIELD;
  const formattedPhoneNumber = phoneNumber ?
    `${phoneNumber.slice(0, 2)} ${phoneNumber.slice(2, 5)}-${phoneNumber.slice(5, 8)}-${phoneNumber.slice(8, 12)}` :
    MISSING_FIELD;

  return (
    <>
      <div className="shadow flex rounded-sm">
        <div className="p-3 flex-1 bg-white text-left">
          <div className="font-bold w-full">
            {fullName}
          </div>
          <div className="w-full flex justify-between text-xs">
            <div className="flex-1">
              <div>{streetAddress}</div>
              <div>{restOfAddress}</div>
            </div>
            <div>
              <div className="text-left text-xs">
                <div>
                  <span style={{ fontFamily: "HelveticaNeue-Bold" }}>DOB: </span>
                  <span>
                    {formattedDob}
                  </span>
                </div>
                <div>
                  <span style={{ fontFamily: "HelveticaNeue-Bold" }}>SSN: </span>
                  <span>
                      XXX-XX-XXXX
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-2 md:flex">
        <div className="flex-1 text-left md:inline-block">
          <div className="shadow flex rounded-sm">
            <div className="p-3 flex-1 bg-white">
              <div className="text-xs">
                <MailClosed className="inline-block text-xs" defaultWidth={16} />
                <span className="ml-2 text-xs">
                  {displayEmail}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-2 text-left md:inline-block md:ml-3 md:mt-0 md:text-center">
          <div className="shadow flex rounded-sm">
            <div className="p-3 flex-1 bg-white">
              <div className="text-xs">
                <Phone className="inline-block" defaultHeight={16} />
                <span className="ml-2">
                  {formattedPhoneNumber}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>

  );
};

export default withQuery(GET_APPLICATION_INFO)(PersonalDetails);